import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useTheme } from '../../DataStore/ThemeContext';
import PopTestConfig from '../../components/Academics/Reports/PopTestConfig';
import { useReport } from '../../DataStore/ReportContext';
import functions from '../../util/functions';
import { useNavigate } from 'react-router-dom';
import AlertRemoveComment from '../../components/Academics/Reports/AlertRemoveComment';
import AlertSetReportComment from '../../components/Academics/AlertSetReportComment';
import { useReportView } from '../../DataStore/ReportViewContext';
import RenderSecure from '../../util/RenderSecure';
import AlertAutoComment from '../../components/Academics/Reports/AlertAutoComment';

const ReportsPage = () => {
  const [loading, setLoading] = useState(false);
  const { openSettings } = useTheme();
  const { getReports, reportListing, setActiveReport, activeReport,  generateMarksheet } = useReport();
  const {generateReports, setSelectedReport} = useReportView();
  const [ activeRow, setActiveRow] = useState(activeReport || null);
  const navigate = useNavigate();


  useEffect(() => {
    getReports();
  }, []);

  useEffect(() => {
    if(activeRow){
      setActiveReport(activeRow);
    }
  }, [activeRow]);


  const handleNewReport = () => {
    openSettings("New Report", "NewReport");
  };

  const handleReportProperties = () => {
    openSettings("Report Properties", "ReportProperties", activeRow);
  }

  const handleEditReport = () => {
    openSettings("Edit Report", "EditReport", activeRow);
  }

  const handleReportsView = (report) => {
    setActiveReport(report);
    setSelectedReport(report);
    generateReports(true, report.id);
    navigate(`/academics-report-view`);
  }

  const handleMarksheetView = (report) => {
    setActiveReport(report);
    setSelectedReport(report);
    generateMarksheet(true, report.id);
    navigate(`/academics-marksheet`);
  }

  const PageActions = () => (
    <>
      <ActionDropdownItem iconClass="fa fa-plus text-success" label="New Report" onClick={handleNewReport} />
      {activeRow && <ActionDropdownItem iconClass="fa fa-info-circle text-info" label="Properties" onClick={handleReportProperties} />}
      {activeRow && <ActionDropdownItem iconClass="fa fa-edit text-info" label="Edit Report" onClick={handleEditReport}/>}
      <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={()=>getReports(true)} />
    </>
  );

  return (
    <>
      <PageContainer>
        <MainContent>
          <PageTitle
            title="Report Cards"
            description="Generate and view report cards for students."
            iconClass="fa fa-book-open"
            PageActions={PageActions}
          />

          <div className="card mb-3">
            <div className="card-body">
              {loading ? (
                <ActivityLoader />
              ) : reportListing === "404" || !Array.isArray(reportListing) ? (
                <Notification message="No report cards found." />
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>No.</th>
                        <th>Title</th>
                        <th>Report Format</th>
                        <th>Class</th>
                        <th>Term</th>
                        <th>Year</th>
                        <th>Tests</th>
                        <th>Date</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportListing.map((report, index) => (
                        <tr
                            key={report.id}
                            onClick={() => setActiveRow(report)}
                            className={activeRow?.id === report.id ? 'table-active' : ''}
                            style={{ cursor: 'pointer' }}
                           >
                          <td>{index + 1}</td>
                          <td>{report.title}</td>
                          <td>{report.report_format?.format_name || '-'}</td>
                          <td>{report.class?.class_name || '-'}</td>
                          <td>{report.term?.term || '-'}</td>
                          <td>{report.year}</td>
                          <td>
                            {report.report_tests?.map((test, i) => (
                              <div key={i}>
                                {test.test.exam_name} ({test.out_of_exact})
                              </div>
                            )) || '-'}
                          </td>
                          <td>{ functions.formatDate(report.report_date)}</td>
                          <td style={{textAlign: 'right'}}>
                            <RenderSecure code="GENERATE_REPORT_CARDS">
                              <button
                                className="btn btn-sm btn-outline-danger mr-2"
                                onClick={() => handleReportsView(report)}
                              >
                                <i className="fa fa-eye"></i> Report Cards
                              </button>
                            </RenderSecure>
                            <RenderSecure code="GENERATE_MARKSHEET">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => handleMarksheetView(report)}
                              >
                                <i className="fa fa-print"></i> Marksheets
                              </button>
                            </RenderSecure>
                            
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </MainContent>
      </PageContainer>
      <PopTestConfig />
      <AlertRemoveComment />
      <AlertSetReportComment /> {/** Report comment writer */}
      <AlertAutoComment />
    </>
  );
};

export default ReportsPage;
